<template>
  <div>
    <ReceiptQuery v-show="activeKey===1" ref="list" :order-status="orderStatus" :refundable="refundable" :storers="storers" @receive="receive"/>
    <ReceiptEdit v-show="activeKey===2" ref="detail" :order-status="orderStatus" :refundable="refundable" :storers="storers" @back="back"/>
  </div>
</template>
<script>
import { getEnums, getOptions } from '@/utils/util'
import ReceiptQuery from '@/views/inbound/receipt/ReceiptQuery'
import ReceiptEdit from '@/views/inbound/receipt/ReceiptEdit.vue'

export default {
  name: 'Receipt',
  components: { ReceiptQuery, ReceiptEdit },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      storers: []
    }
  },
  created() {
    getOptions('storerFactory', { available: true }).then(result => {
      this.storers = result
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    receive(row) {
      this.activeKey = 2
      this.$refs.detail.clear()
      this.$refs.detail.refresh(row)
    }
  }
}
</script>